import { welcomeVideoUrl } from '@/core/guidance/constants';
import { useDictionary } from '@/core/providers/dictionary-provider';

/**
 * Welcome media for orientation step 0.
 * Placeholder UI is omitted until a real video URL is configured
 * (App Review: unfinished “coming soon” media reads as incomplete).
 */
export function WelcomeStepContent() {
  const dict = useDictionary();
  const copy = dict.guidance.tours.orientation.welcome;
  const url = welcomeVideoUrl();

  if (url) {
    return (
      <div className="space-y-3">
        <p className="text-pretty text-sm leading-relaxed text-muted-foreground">
          {copy.body}
        </p>
        <div className="overflow-hidden rounded-[var(--radius-nested,0.75rem)] border border-border bg-muted/30">
          <video
            className="aspect-video w-full object-cover"
            controls
            playsInline
            preload="metadata"
            src={url}
          >
            <track kind="captions" />
          </video>
        </div>
      </div>
    );
  }

  return (
    <p className="text-pretty text-sm leading-relaxed text-muted-foreground">
      {copy.body}
    </p>
  );
}
